import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { CodePreview, TabPanel, Tabs } from './ui';
export var GeneratedScript = function (_a) {
    var scripts = _a.scripts;
    var tabs = useMemo(function () { return scripts.map(function (script) { return ({ label: script.label }); }); }, [scripts]);
    return (_jsx(Tabs, { variant: 'enclosed', tabs: tabs, children: scripts.map(function (script) { return (_jsx(TabPanel, { children: _jsx(CodePreview, { code: script.script, codeBlockClassName: 'border border-gray-300 -mt-px' }) }, "tab-panel-".concat(script.label))); }) }));
};
